import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Table, Card, CardBody, Badge, Button, UncontrolledTooltip, FormGroup,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import CalendarIcon from 'mdi-react/CalendarIcon';
import DatePicker from 'react-datepicker';
import MinusIcon from 'mdi-react/MinusIcon';
import Moment from 'moment';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';

import global from '../../../global';
import CommonService from '../../../services/CommonService';
import EditInventory from '../../Inventory/components/BatchUpdateModal';

class ReceivedStock extends Component {
  static propTypes = {
    locationid: PropTypes.string.isRequired,
    pagetype: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    const { pagetype } = this.props;
    this.state = {
      realList: [],
      list: [],
      formdata: {},
      modal: false,
      title: 'Stock Tracker',
      locationName: '',
      goTo: false,
      lastPageVisited: window.history.state !== null && window.history.state !== undefined && window.history.state !== '' ? window.history.state.state.prevpage : pagetype === 'batches' ? '/inventory' : '',
      errorMsg: '',
    };
    this.userdata = JSON.parse(localStorage.getItem('userData'));
    this.searchTransaction = this.searchTransaction.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
     this.isLoading = true;
     this.onLoadStockTransactions();
  }

  onLoadStockTransactions = async (fromDate = '', toDate = '') => {
    try {
      const { locationid, pagetype } = this.props;
      const dateFrom = fromDate !== '' ? fromDate : Moment(new Date()).format('YYYY-MM-DD');
      const dateTo = toDate !== '' ? toDate : Moment(new Date()).format('YYYY-MM-DD');

       const location = `/fromdate/${dateFrom}/todate/${dateTo}/locationid/${locationid}/pagetype/${pagetype}`;
       const response = await CommonService.getRows(`stocktrackerlist${location}`);
       if (response.result !== false) {
          this.setState({ list: response.list, realList: response.list });
          this.setState({ locationName: response.location_name });
          this.handleClick();
       }
    } catch (err) {
       console.log('Error: ', err.message);
    }
    this.isLoading = false;
  }

  cancelTransactionToggle = (e, stockId, status) => {
    e.preventDefault();
    const { locationid } = this.props;
    const { list } = this.state;
    swal({
      title: 'Confirmation',
      text: 'Are you sure you want to cancel this transaction?',
      icon: 'warning',
      buttons: {
        yes: 'YES',
        no: 'NO',
      },
    }).then((btnName) => {
      btnName = btnName.toLowerCase();
      const postdata = {
        stockId,
        status,
        locationid,
      };

      if (btnName === 'yes') {
        CommonService.updateData('cancelwarehousetransaction', postdata).then((response) => {
          if (response === true) {
              list.filter((listResp) => {
                if (listResp.stock_movement_id === stockId) {
                  listResp.status = postdata.status;
                }
                return listResp;
              });
          } else {
            swal('', 'Failed to cancel transaction', 'warning');
          }
        });
      }
    });
  }

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  LeGoTo = (ev) => {
    window.location.href = `/demoinventory${ev.currentTarget.dataset.href}`;
  }

  goBack = () => {
    this.setState({ goTo: true });
  }

  handleChange = (e, fieldName) => {
    if (fieldName === 'fromDate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata,
          fromDate: date,
        },
      }));
    } else if (fieldName === 'toDate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata,
          toDate: date,
        },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  }

  async editSubmitForm(e, batchid) {
    e.preventDefault();
    e.stopPropagation();
    const form = document.getElementById('updateInventory_form');
    const formdata = new FormData(form);
    formdata.append('batchid', batchid);
    formdata.append('updated_by', this.userdata.user_id);

    try {
      const response = await CommonService.updateData('updatewarehousestock', formdata, false);
        if (response) {
          const { list } = this.state;
          list.filter((listResp) => {
            if (listResp.batch_id === batchid && response.formdata) {
              const formkeys = Object.keys(response.formdata);
              const formvalue = Object.values(response.formdata);
              formkeys.map((item, value) => {
                listResp[item] = formvalue[value];
                return console.log(item, formvalue[value]);
              });
            }
            return listResp;
          });
          this.setState({ list, modal: false });
          swal('', 'Successfully updated user information!', 'success');
        }
   } catch (err) {
      console.log(err.message);
      this.isLoading = false;
   }
  }

  editToggle(e, batchid) {
    e.preventDefault();
    e.stopPropagation();
    this.toggleModal('Edit Room');

    this.setState({
        formdata: {
            batch_id: batchid,
        },
    });

    this.handleSubmit = (formEvent) => {
      this.editSubmitForm(formEvent, batchid);
    };
  }

  handleClick(event = '') {
    const selected = event !== '' ? event.selected + 1 : 1;
    const { realList } = this.state;

    const lastPost = selected * 10;
    const firstPost = lastPost - 10;

    const newList = realList.slice(firstPost, lastPost);
    this.setState({ list: newList });
 }

  searchTransaction(e) {
    e.preventDefault();
    const { formdata } = this.state;
    const fromDate = Moment(formdata.fromDate).format('YYYY-MM-DD');
    const toDate = Moment(formdata.toDate).format('YYYY-MM-DD');
    this.onLoadStockTransactions(fromDate, toDate);
  }

  render() {
      const {
        list, formdata, title, locationName, goTo, lastPageVisited, modal, errorMsg, realList,
      } = this.state;
      const { locationid, pagetype } = this.props;

      if (goTo === true) {
        return <Redirect to={{ pathname: lastPageVisited }} />;
      }

      const locName = locationName !== '' ? ` - ${locationName}` : '';
      const pageTitle = pagetype === 'received' ? 'Receiving Report'
                      : pagetype === 'batches' ? 'Stock Batches'
                      : pagetype === 'stockout' ? 'Stock Out'
                      : pagetype === 'stocksold' ? 'Sold Stocks'
                      : pagetype === 'stockin' ? 'Stock In' : title;

      // from date
      let fromDate = new Date();
      if (formdata.fromDate) {
        fromDate = new Date(formdata.fromDate);
      }
      // to date
      let toDate = new Date();
      if (formdata.toDate) {
        toDate = new Date(formdata.toDate);
      }
      console.log(list);
    return (
      <Card className="panel panel--primary do_magic" id="users_table">
        <EditInventory
            icon="fa fa-plus"
            btn="Edit Room"
            modal={modal}
            handleChange={this.handleChange}
            toggle={this.toggleModal}
            handleSubmit={this.handleSubmit}
            errorMsg={errorMsg}
            postValue={formdata}
            locationID={this.locationID}
            locationType="1"
        />
        <CardBody className="panel__body">
          <div className="panel__title bg_blue">
            <h5 className="bold-text">{`${pageTitle}${locName}`}</h5>
            <div className="panel__btns">
              {
                lastPageVisited !== '' ? (
                  <Button onClick={this.goBack} className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" size="sm" outline>
                    <i className="fa fa-arrow-left" />
                    <span>Back</span>
                  </Button>
                ) : ''
              }
            </div>
          </div>
          <div className="panel__content">
            <Col md={12} className="p-0">
              {
                pagetype !== 'batches' ? (
                  <Button color="primary" className="rounded" size="sm" onClick={this.LeGoTo} data-href={`/stockstracker/${locationid}/batches/list`}>Stock Batches</Button>
                ) : ''
              }

                <div className="float-right">
                  <form className="form form--horizontal" onSubmit={this.searchTransaction}>
                    <div className="form__form-group">
                      <div className="form__form-group-field rfull-width">
                        <span className="form__form-group-label text-right m-r-10 mw-45 xw-45">Date:</span>
                        <div className="form__form-group-icon">
                          <CalendarIcon />
                        </div>
                        <DatePicker
                          name="fromDate"
                          selected={fromDate}
                          popperPlacement="top"
                          onChange={e => this.handleChange(e, 'fromDate')}
                        />
                        <MinusIcon className="date-picker__svg m-t-5" />
                        <div className="form__form-group-icon">
                          <CalendarIcon />
                        </div>
                        <DatePicker
                          name="toDate"
                          selected={toDate}
                          popperPlacement="top-end"
                          onChange={e => this.handleChange(e, 'toDate')}
                        />
                        <button type="submit" className="form__form-group-button bg-primary"><i className="fa fa-search" /></button>
                      </div>
                    </div>
                  </form>
                </div>

                {
                  pagetype === 'stockout' || pagetype === 'stockin' || pagetype === 'stocksold' ? (
                  <Table responsive striped className="doResTable">
                    <thead>
                        <tr>
                            <th>DR #</th>
                            <th>Product</th>
                            <th>Batch Code</th>
                            <th>{pagetype === 'stockout' || pagetype === 'stocksold' ? 'Deliver To' : 'Delivered From'}</th>
                            <th>Date</th>
                            <th>Quantity</th>
                            {
                              this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                                <>
                                  <th>Unit Price</th>
                                  <th>Total</th>
                                </>
                              )
                            }

                            {
                              pagetype !== 'stocksold' && (
                                <>
                                  <th>Status</th>
                                </>
                              )
                            }

                            {
                              pagetype === 'stockout' && (
                                <>
                                  <th>Action</th>
                                </>
                              )
                            }
                        </tr>
                    </thead>

                    <tbody>
                      {
                        list !== false || list.length > 0 ? list.map((item, i) => {
                          const itemQuantity = item.quantity ? global.parseToNumber(item.quantity) : 0;
                          const unitCost = item.unit_cost ? global.parseToNumber(item.unit_cost) : 0;
                          const itemTotal = itemQuantity * unitCost;
                          const inventoryDate = Moment(item.date_delivered).format('MMMM DD, YYYY');
                          item.status = parseInt(item.status, 10);

                          let statusColor = 'success';
                          if (item.status === 0) {
                            statusColor = 'warning';
                          } else if (item.status === 2 || item.status === 3) {
                            statusColor = 'danger';
                          }

                            return (
                              <tr key={item.stock_movement_id}>
                                <td>{item.delivery_number}</td>
                                <td>{item.product_name}</td>
                                <td>{item.batch_code}</td>
                                <td>{item.location_name}</td>
                                <td>{inventoryDate}</td>
                                <td>{itemQuantity} kgs.</td>
                                {
                                  this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                                    <>
                                      <td>&#x20B1; {global.numberFormat(unitCost)}</td>
                                      <td>&#x20B1; {global.numberFormat(itemTotal)}</td>
                                    </>
                                  )
                                }

                                {
                                  pagetype !== 'stocksold' && (
                                    <>
                                      <td><Badge color={statusColor}>{global.movementStatus[(item.status !== 1 ? item.status : 4)]}</Badge></td>
                                    </>
                                  )
                                }

                                {
                                  pagetype === 'stockout' && (
                                    <>
                                      <td>
                                        {
                                          item.status === 0 ? (
                                            <>
                                            <Button color="danger" className="btn-xs" onClick={e => this.cancelTransactionToggle(e, item.stock_movement_id, 3)} id={`cancelbtn${i + 1}`} outline><span className="fa fa-times" /></Button>
                                            <UncontrolledTooltip placement="bottom" target={`cancelbtn${i + 1}`}>Cancel Transaction</UncontrolledTooltip>
                                            </>
                                          ) : '- -- -'
                                        }
                                      </td>
                                    </>
                                  )
                                }
                              </tr>
                            );
                        }) : (
                            <tr className="text-center">
                              <td colSpan="12">No data available..</td>
                            </tr>
                        )
                      }
                    </tbody>
                  </Table>
                  ) : pagetype === 'batches' ? (
                    <Table responsive striped className="doResTable">
                      <thead>
                          <tr>
                              <th>Ref #</th>
                              <th>Product</th>
                              <th>Batch Code</th>
                              <th>Supplier</th>
                              <th>Room</th>
                              <th>Date</th>
                              <th>Quantity</th>
                              <th>Stock Out</th>
                              <th>Transfers</th>
                              <th>Remaining Stock</th>
                              {
                                this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                                  <>
                                    <th>Unit Price</th>
                                    <th>Total</th>
                                  </>
                                )
                              }
                              <th>Action</th>
                          </tr>
                      </thead>

                      <tbody>
                        {
                          list !== false || list.length > 0 ? list.map((item, i) => {
                            const itemQuantity = item.quantity ? global.parseToNumber(item.quantity) : 0;
                            const itemRemaining = item.balance_new ? item.balance_new : 0;
                            const unitCost = item.unit_cost ? global.parseToNumber(item.unit_cost) : 0;
                            const itemTotal = itemRemaining * unitCost;
                            const inventoryDate = Moment(item.date_received).format('MMMM DD, YYYY');

                              return (
                                <tr key={`cust_tr${i + 1}`}>
                                    <td>{item.reference_number}</td>
                                    <td>{item.product_name}</td>
                                    <td>{item.batch_code}</td>
                                    <td>{item.supplier_name}</td>
                                    <td>{item.room}</td>
                                    <td>{inventoryDate}</td>
                                    <td>{itemQuantity} kgs.</td>
                                    <td>{item.total_out} kgs.</td>
                                    <td>{item.total_transfer} kgs.</td>
                                    <td>{item.balance_new} kgs.</td>
                                    {
                                      this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                                        <>
                                          <td>&#x20B1; {global.numberFormat(unitCost)}</td>
                                          <td>&#x20B1; {global.numberFormat(itemTotal)}</td>
                                        </>
                                      )
                                    }
                                    <td>
                                    <Button color="primary" className="btn-xs" onClick={e => this.editToggle(e, item.batch_id)} id={`editbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                                    </td>
                                </tr>
                              );
                          }) : (
                              <tr className="text-center">
                                <td colSpan="12">No data available..</td>
                              </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  ) : (
                    <Table responsive striped className="doResTable">
                      <thead>
                          <tr>
                              <th>Ref #</th>
                              <th>Product</th>
                              <th>Batch Code</th>
                              <th>Supplier</th>
                              <th>Date</th>
                              <th>Quantity</th>
                              {
                                this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                                  <>
                                    <th>Unit Price</th>
                                    <th>Total</th>
                                  </>
                                )
                              }
                          </tr>
                      </thead>

                      <tbody>
                        {
                          list !== false || list.length > 0 ? list.map((item, i) => {
                            const itemQuantity = item.quantity ? global.parseToNumber(item.quantity) : 0;
                            const unitCost = item.unit_cost ? global.parseToNumber(item.unit_cost) : 0;
                            const itemTotal = itemQuantity * unitCost;
                            const inventoryDate = Moment(item.date_received).format('MMMM DD, YYYY');

                              return (
                                <tr key={`cust_tr${i + 1}`}>
                                    <td>{item.reference_number}</td>
                                    <td>{item.product_name}</td>
                                    <td>{item.batch_code}</td>
                                    <td>{item.supplier_name}</td>
                                    <td>{inventoryDate}</td>
                                    <td>{itemQuantity} kgs.</td>
                                    {
                                      this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                                        <>
                                          <td>&#x20B1; {global.numberFormat(unitCost)}</td>
                                          <td>&#x20B1; {global.numberFormat(itemTotal)}</td>
                                        </>
                                      )
                                    }
                                </tr>
                              );
                          }) : (
                              <tr className="text-center">
                                <td colSpan="12">No data available..</td>
                              </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  )
                }
            </Col>
            <FormGroup className={list === false || (realList.length / 10) <= 1 ? 'display-none' : ''}>
              <ReactPaginate
                  previousLabel="<<"
                  nextLabel=">>"
                  breakLabel="..."
                  breakClassName="break-me"
                  pageCount={realList.length / 10}
                  onPageChange={this.handleClick}
                  marginPagesDisplayed={0}
                  pageRangeDisplayed={2}
                  containerClassName="list-pagination"
                  activeClassName="active"
              />
            </FormGroup>
          </div>
        </CardBody>
      </Card>
    );
  }
}

export default withTranslation('common')(ReceivedStock);
